import API from "@/lib/httpModule";

/**
 * Create booking
 * @returns
 */
export async function createBooking(payload) {
	return API.post(`/suite-request`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Update booking
 * @returns
 */
export async function updateBooking(requestId, payload) {
	return API.put(`/suite-request/${requestId}`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Cancel bookings
 * @returns
 */
export async function cancelBooking(requestId, payload) {
	return API.put(`/suite-request/${requestId}/cancel`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get bookings
 * @returns
 */
export async function getBookings(query) {
	return API.get(`/suite-request`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get booking detail by id
 * @param {String} slug
 * @returns
 */
export async function getBookingDetail(slug) {
	return API.get(`/suite-request/${slug}`)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Request jet 1 suites access
 * @returns
 */
export async function requestJetOneSuiteAccess(payload) {
	return API.put(`/user/request-suite-access`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}
